import { faBuilding } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button, DialogActions, DialogContent
} from '@mui/material';
import { Question, RequiredSelectHack } from 'components';
import React from 'react';
import { isMobileOnly } from 'react-device-detect';
import Select from 'react-select';
import { useForm, Controller } from 'react-hook-form';
import { translate } from 'utils/helpers';
import { StructureLevelOption } from 'utils/types/StructureLevelOption';
import {
  StructureLevelSelectOption,
  StructureLevelSelectValue
} from '../Form/ItemOption/StructureLevelSelectOption';
import { ModalHeader } from './ModalHeader';

export const UpdateUserLevelModal = ({
                                       onClose, onConfirm, defaultLevel, levelOptions
                                     }: {
  defaultLevel: StructureLevelOption,
  levelOptions: StructureLevelOption[],
  onClose: () => void,
  onConfirm: (selectedLevel: StructureLevelOption) => void
}) => {
  // Initialiser React Hook Form avec la valeur par défaut
  const {
 control, handleSubmit, formState: { errors }, watch
} = useForm({
    defaultValues: {
      level: levelOptions.find(insti => insti.value === defaultLevel.value)
    }
  });

  const levelValue = watch('level');

  const handleCloseModal = () => {
    localStorage.setItem('isLevelSet', 'true');
    onClose();
  };

  const handleValidateModal = (data) => {
    onConfirm(data.level);
    handleCloseModal();
  };

  return (
    <form onSubmit={handleSubmit(handleValidateModal)}>
      <ModalHeader onClose={onClose}>
        <FontAwesomeIcon icon={faBuilding} />
        {translate('modalInstitutionUpdate.title')}
      </ModalHeader>

      <DialogContent style={{ paddingTop: '10px' }}>
        <Question label={translate('modalInstitutionUpdate.selectInstitution')}>
          <Controller
                control={control}
                name="level"
                render={({ field }) => (
                  <Select
                        components={{ Option: StructureLevelSelectOption, SingleValue: StructureLevelSelectValue }}
                        id="selectLevel"
                        isClearable
                        isSearchable
                        menuPlacement={isMobileOnly ? 'top' : 'bottom'}
                        menuPortalTarget={document.body}
                        noOptionsMessage={() => translate('warnings.noOptionsAvailable')}
                        options={levelOptions}
                        placeholder={translate('common.searchByInstitution')}
                        styles={{ menuPortal: base => ({ ...base, zIndex: 2000 }), container: () => ({ minWidth: isMobileOnly ? 200 : 500 }) }}
                        value={field.value || ''}
                        onChange={(value) => field.onChange(value)}
                    />
                )}
            />
          <RequiredSelectHack value={levelValue || ''} />
        </Question>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleCloseModal}>{translate('button.cancel')}</Button>
        <Button color="primary" type="submit">{translate('button.save')}</Button>
      </DialogActions>
    </form>
  );
};
